import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { PurchaseDocument, ContractDocumentsError } from '../../types'

import ContractDocumentFileUploaderBlock from './PurchaseDocumentFileUploaderBlock'
import { Slide, ToastContainer } from 'react-toastify'

type Props = {
    theme: string
    purchaseAction: boolean
    purchaseGuid: string | undefined
    role: string
    onPurchaseDocuments: (have_purchase_documents: boolean) => void
    errors?: ContractDocumentsError
}

const PurchaseDocumentTable: React.FC<Props> = (props) => {
    const [purchaseDocuments, setPurchaseDocuments] = useState<
        PurchaseDocument[] | null
    >(null)
    const [isLoadingPurchaseDocuments, setLoadingPurchaseDocuments] =
        useState(false)

    const [selectedItems, setSelectedItems] = useState<string[]>([])
    const [selectAll, setSelectAll] = useState<boolean>(false)

    const [isAttachment, setAttachment] = useState(true)

    const getPurchaseDocuments = async (): Promise<PurchaseDocument[]> => {
        setLoadingPurchaseDocuments(true)
        return fetch(
            `${process.env.REACT_APP_API_URL}/api/backend/v1/purchase/attachments?purchase_guid=${props.purchaseGuid}`,
            {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        )
            .then((response) => {
                if (response.ok) {
                    return response.json()
                } else {
                    throw new Error('Ошибка запроса на документы')
                }
            })
            .catch((e) => {
                // console.error(e)
            })
            .finally(() => {
                setLoadingPurchaseDocuments(false)
            })
    }

    // Функция для обработки изменения состояния отдельного checkbox
    const handleCheckboxChange = (perfDocument_guid: string) => {
        setSelectedItems((prevSelectedItems) => {
            if (prevSelectedItems.includes(perfDocument_guid)) {
                return prevSelectedItems.filter(
                    (itemId) => itemId !== perfDocument_guid
                )
            } else {
                return [...prevSelectedItems, perfDocument_guid]
            }
        })
    }

    // Функция для обработки изменения состояния отдельного checkbox при нажатии правой кнопкой
    const handleRightClickCheckboxChange = (perfDocument_guid: string) => {
        setSelectedItems((prevSelectedItems) => {
            if (prevSelectedItems.includes(perfDocument_guid)) {
                return prevSelectedItems // Если уже выбран, ничего не меняем
            }
            return [...prevSelectedItems, perfDocument_guid] // Добавляем в выбранные
        })
    }

    // Функция для обработки изменения состояния "Select All"
    const handleSelectAllChange = () => {
        setSelectAll(!selectAll)
        if (!selectAll) {
            // Выбираем только те элементы, которые соответствуют текущей стадии
            const filteredItems = purchaseDocuments
                ? purchaseDocuments.map((item) => item.guid)
                : []

            setSelectedItems(filteredItems)
        } else {
            // Сбрасываем выбор всех элементов
            setSelectedItems([])
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (props.purchaseGuid) {
                    const purchDocuments = await getPurchaseDocuments()
                    if (purchDocuments) {
                        setPurchaseDocuments(purchDocuments)
                    }
                }
            } catch (error) {
                console.error('Ошибка при загрузке данных:', error)
            }
        }
        fetchData()
    }, [])

    return (
        <fieldset disabled={false}>
            <div className="flex flex-col space-y-1 w-full items-center justify-start">
                <ContractDocumentFileUploaderBlock
                    theme={props.theme}
                    purchaseAction={props.purchaseAction}
                    purchaseGuid={String(props.purchaseGuid)}
                    isAttachment={isAttachment}
                    role={props.role}
                    onPurchaseDocuments={props.onPurchaseDocuments}
                    errors={props.errors}
                    // onAnyEdit={props.onAnyEdit}
                />

                <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar
                    newestOnTop
                    closeOnClick
                    draggable
                    pauseOnHover
                    theme={props.theme == 'dark' ? 'dark' : 'light'}
                    transition={Slide}
                    className="!z-[9999]"
                    toastClassName={() =>
                        'flex w-fit min-h-[40px] px-3 py-2 items-center gap-2 bg-[#f6f6f6] dark:bg-[#2A282B] rounded-xl shadow-xl text-[#181818] dark:text-[#FFFFFF] text-[13px] my-1'
                    }
                />
            </div>
        </fieldset>
    )
}

export default PurchaseDocumentTable
